export function getNodeindex(element) {
  return [...element.parentNode.children].indexOf(element);
}

export function cookiesEnabled() {
  return navigator.cookieEnabled;
}
